var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('welcome-g-a-image'),_c('div',{staticClass:"uk-padding"},[_c('div',{staticClass:"uk-container"},[_c('grad-requirements')],1)]),_c('alternate-grad-requirements'),_c('explore-grad-programs'),_c('incomplete-applications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }